export enum Feature {
  ActionableTaskView = 'Actionable Task View',
  AdvancedCalendarView = 'Advanced Calendar View',
  BlockTeamlessBoards = 'Block Teamless Boards',
  BoardsPageTemplatePicker = 'Boards Page Template Picker',
  BoardViewsButton = 'Board Views Switcher',
  ButlerOnBoards = 'Butler on Boards',
  CardDetailDialog = 'Card Detail Dialog',
  CardFrontLinks = 'Card Front Links',
  Checklists = 'Checklists',
  Collections = 'Collections',
  CovidChurn = 'Covid Churn',
  FreeTeamOnboarding = 'Free Team Onboarding',
  FreeTrialExistingTeam = 'Free Trial Existing Team',
  Madlibs = 'Madlibs',
  MarkdownTracker = 'Markdown Tracker',
  MigrationWizard = 'Migration Wizard',
  Moonshot = 'moonshot',
  MultiBoardTableView = 'Multi-Board Table View',
  NuSkuBillingView = 'NuSku Billing View',
  PluginPermissions = 'Plugin Permissions',
  PushTouchpointsSwitcherSpotlight = 'PushTouchpointsSwitcherSpotlight',
  SmartLink = 'Smart Link',
  TeamEditAvatar = 'Team Edit Avatar',
  TeamOnboarding = 'Team Onboarding',
  TeamProfile = 'Team Profile Header',
  TeamTemplatePicker = 'Team Template Picker',
  TemplateCard = 'Template Card',
  TemplatePicker = 'Template Picker',
  TemplatesGallery = 'Templates Gallery',
  TemplatesInCreateFlow = 'Templates In Create Flow',
  TemplateTips = 'Template Tips',
  TimelineView = 'Timeline View',
  UndoAction = 'Undo Action',
  UpgradePrompt = 'Upgrade Prompt',
  WorkspaceNavigation = 'Workspace Navigation',
  WorkspaceSwitcher = 'Workspace Switcher',
  WorkspacesAutoNameAlert = 'Workspaces Auto Name Alert',
  WorkspacesPreamble = 'Workspaces Preamble',
  LinkCardLoadAnalysis = 'Link Card Load Analysis',
}
